import React from 'react';
import PropTypes from 'prop-types';
import { useNode } from '@splashthat/splash-cms-engine';

import { useTouchpointData } from 'common/components/TouchpointEditor/contexts/TouchpointDataContext';

import { HeaderStyles } from './Header.styles';
import { STACK_LAYOUT, SIDE_BY_SIDE_LAYOUT } from '../../../constants';

const BASE_CLASS_NAME = 'Header';

export default function Header({
    children,
    styles: { backgroundColor, backgroundImageUrl },
    meta: { layout },
    selected,
    hovered,
}) {
    const { theme } = useTouchpointData();
    const node = useNode();

    return (
        <HeaderStyles
            selected={selected}
            hovered={hovered}
            onMouseLeave={node.actions.onMouseLeave()}
            onMouseMove={node.actions.onMouseMove()}
            data-qa={`${BASE_CLASS_NAME}--container`}
            data-qa-layout={layout}
            $stacked={layout === STACK_LAYOUT}
            onClick={node.actions.onClick()}
            $backgroundColor={theme.colors[backgroundColor]}
            $backgroundImageUrl={backgroundImageUrl}
        >
            {children}
        </HeaderStyles>
    );
}

Header.splash = {
    related: {
        settings: React.lazy(() => import('./Header.tools')),
    },
    defaultProps: {
        styles: {
            backgroundColor: '',
            backgroundImageUrl: '',
        },
        meta: {
            layout: SIDE_BY_SIDE_LAYOUT,
        },
    },
};

Header.propTypes = {
    children: PropTypes.node,
    meta: PropTypes.shape({
        layout: PropTypes.string,
    }).isRequired,
    selected: PropTypes.bool.isRequired,
    hovered: PropTypes.bool.isRequired,
    styles: PropTypes.shape({
        backgroundColor: PropTypes.number,
        backgroundImageUrl: PropTypes.string,
    }).isRequired,
};

Header.defaultProps = {
    children: null,
};
